import React from 'react';
import { Button, Grid } from 'semantic-ui-react';

import { Typography } from 'components/_common/Typography';
import { BdDatePicker } from 'components/BdDatePicker';

type CustomTimeframeProps = {
  fieldName: string;
  label: string;
  dateErrors: any;
  onCancel: () => void;
  onSubmit: () => void;
  autoFocusMonth?: boolean;
};

export const CustomTimeframeControl: React.FC<CustomTimeframeProps> = ({
  fieldName,
  label,
  dateErrors,
  onCancel,
  onSubmit,
  autoFocusMonth,
}) => {
  return (
    <>
      <Typography variant="subtitle2" color="stone90">
        {label}
      </Typography>
      <BdDatePicker autoFocusMonth={autoFocusMonth} name={fieldName} />
      {Array.isArray(dateErrors) ? (
        (dateErrors as string[]).map(err => (
          <Typography variant="caption" color="starfish100" key={err}>
            {err}
          </Typography>
        ))
      ) : (
        <Typography variant="caption" color="stone90">
          Specify a date after Jan 1, 2019
        </Typography>
      )}
      <Grid columns="equal" relaxed="very" className="timeframe__buttons">
        <Grid.Column>
          <Button fluid type="button" size="small" secondary onClick={onCancel}>
            Cancel
          </Button>
        </Grid.Column>
        <Grid.Column>
          <Button fluid type="button" size="small" primary onClick={onSubmit}>
            Update timeframe
          </Button>
        </Grid.Column>
      </Grid>
    </>
  );
};
